import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import { TechRadarStatusDto } from '@internal/backstage-plugin-techradar-evaluation-common';
import { TechRadarApi } from './TechRadarApi';

export class TechRadarApiClient implements TechRadarApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async fetchStatus(entityRef: string): Promise<TechRadarStatusDto> {
    const baseUrl = await this.discoveryApi.getBaseUrl('techradar');
    const res = await this.fetchApi.fetch(`${baseUrl}/status/${entityRef}`);
    if (!res.ok) {
      throw new Error(`Failed to fetch tech radar status: ${res.status} ${res.statusText}`);
    }
    return res.json();
  }
}
